import React from "react";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import palette from "./lightPalette";
import darkPalette from "./darkPalette";
import classes from "./classes";
import typography from "./typography";
import overrides from "./overrides";

// https://material-ui.com/es/customization/palette/#dark-mode

const ThemeProvider = ({ children, lightMode }) => {
  React.useEffect(() => {
    const WebFont = require("webfontloader");
    WebFont.load({
      google: {
        families: [
          "Rubik:ital,wght@0,300;0,400;0,700;0,900;1,400&display=swap",
        ],
      },
    });
  }, []);

  const theme = React.useMemo(
    () =>
      createMuiTheme({
        palette: lightMode ? palette : darkPalette,
        ...classes,
        ...typography,
        ...overrides,
      }),
    [lightMode]
  );
  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
};

export { ThemeProvider };
export default ThemeProvider;
